export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const EDIT_USER = 'EDIT_USER';
export const CREATE_USER = 'CREATE_USER';
export const LOAD_USERS_LIST = 'LOAD_USERS_LIST';
export const EDIT_BALANCE = 'EDIT_BALANCE';
export const CHANGE_USER_WORK_STATUS = 'CHANGE_USER_WORK_STATUS';
export const EDIT_SUPPORT_LIMIT = 'EDIT_SUPPORT_LIMIT';
export const RESET_SUPPORT_LIMIT = 'RESET_SUPPORT_LIMIT';
export const DELETE_USER = 'DELETE_USER';
